import React, {Component, Fragment} from 'react';
import {Button, Card, CardBody, CardHeader, Col, FormGroup, FormText, Input, InputGroup, Label, Row} from 'reactstrap';
import 'ladda/dist/ladda-themeless.min.css';
import {getData, postData} from '../../api/doLogin.js';
import {Calendar as BigCalendar, momentLocalizer} from "react-big-calendar";
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import {
  displayMilHoursMinutesFromTime,
  forceSingleTimeZone,
  formatDateTime,
  formatDateTimeLocal,
  formatTimeFromEpoch,
  formatUTCTimeFromEpoch,
  makeDate
} from "../../util/datehelpers";
import {LoadingDialog} from "../../components/Shared/LoadingDialog";
import {EventClient} from "../../util/eventClient";
import {getAARStatus} from "../../constants/AARConstants";
import "./views/MyCalendar.css"
import {MakeDialog} from "../../components/Shared/MakeDialog";
import {deleteData} from "../../api/doLogin";
import {RequiredPermissions} from "../../api/permissions";
import {hasPermission} from "../../api/permissionHelper";
//https://github.com/jquense/react-big-calendar/tree/af82bd75466c1b3ca699cb2427a342bbbbeef0a3
//http://intljusticemission.github.io/react-big-calendar/examples/index.html#dnd

const brandPrimary = '#20a8d8';
const brandSuccess = '#4dbd74';
const brandInfo = '#63c2de';
const brandWarning = '#f8cb00';
const brandDanger = '#f86c6b';

let localizer = momentLocalizer(moment)

// const DraggableBigCalendar = withDragAndDrop(BigCalendar);

export class MyCalendar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      dataLoaded: false,
      preview: null,
      showPicker: false,
      tempData: {},
      cal_id: 0,
      events: [],
      calendarList: [],
      chosenCalendar: props['match']['params']['user_id'] || this.props.loginID,
      lead: null,
      loading: true,
      dateRange: {
        start: 0,
        end: 0
      },
      fetchRange: {
        start: (Math.round((new Date()).getTime() / 1000)) - (60 * 24 * 3600),
        end: (Math.round((new Date()).getTime() / 1000)) + (60 * 24 * 3600)
      },
      currentDate: new Date(),
      currentView: 'month',
      showAddCalEntry: false,
      editID: null,
      formData: {},
      addSelection: {}
    };
    // this.getLeadData.bind(this);
    // this.updateData.bind(this);
  }

  componentDidMount() {
    // this.accessLevel = checkPerms(this.props.perms, [{admin: {cameras: [2]}}]) ? 2 : this.accessLevel;
    // this.accessLevel = checkPerms(this.props.perms, [{admin: {cameras: [3]}}]) ? 3 : this.accessLevel;
    this.computeDisplayedDateRange();
    let self = this;
    // this.getLeadData(() => {
    self.updateData(self.state.fetchRange);
    // });
    EventClient.on("MY_TIMECLOCK_CALENDAR_REFRESH", () => self.updateData(), "TimeClock")
  }

  componentWillUnmount() {
    EventClient.off("MY_TIMECLOCK_CALENDAR_REFRESH", () => this.updateData(), "TimeClock")
  }

//prevState.chosenCalendar !== this.state.chosenCalendar ||
  componentDidUpdate(prevProps, prevState) {
    if (prevProps['match']['params']['user_id'] !== this.props['match']['params']['user_id']) {
      let self = this;
      self.setState({chosenCalendar: this.props['match']['params']['user_id']}, () => {
        self.updateData(self.state.fetchRange);
      })
      return false;
    }
  }

  setCurrentDate(date) {
    this.setState({currentDate: date}, () => {
      this.computeDisplayedDateRange();
    });
  }

  setCurrentView(view) {
    this.setState({currentView: view}, () => {
      this.computeDisplayedDateRange();
    });
  }

  computeDisplayedDateRange() {
    const {currentDate, currentView} = this.state;
    let start = moment(currentDate).startOf(currentView);
    let end = moment(currentDate).endOf(currentView);
    if (currentView === 'month') {
      start = start.startOf('week');
      end = end.endOf('week');
    }
    this.setState({dateRange: {start: start, end: end}}, () => {
      if (currentView !== 'month') {
        start = start.startOf('week');
        end = end.endOf('week');
      }
      // console.log("Start", (Math.round(start.toDate().getTime() / 1000) - this.state.fetchRange.start) - 24 * 3600);
      // console.log("End", (this.state.fetchRange.end - Math.round(end.toDate().getTime() / 1000)) - 24 * 3600);
      if (Math.round(start.toDate().getTime() / 1000) - this.state.fetchRange.start < (32 * 24 * 3600)) {
        const rangeStart = Math.round(start.toDate().getTime() / 1000) - (90 * 24 * 3600);
        const rangeEnd = rangeStart + (150 * 24 * 3600);
        // console.log("newRange", {start: rangeStart, end: rangeEnd});
        this.updateData({start: rangeStart, end: rangeEnd});
      } else if (this.state.fetchRange.end - Math.round(end.toDate().getTime() / 1000) < (32 * 24 * 3600)) {
        const rangeEnd = Math.round(end.toDate().getTime() / 1000) + (90 * 24 * 3600);
        const rangeStart = rangeEnd - (150 * 24 * 3600);
        // console.log("newRange", {start: rangeStart, end: rangeEnd});
        this.updateData({start: rangeStart, end: rangeEnd});
      }
    });
  }


  updateData(fetchRange = {}) {
    if (Object.keys(fetchRange).length === 0) {
      fetchRange = this.state.fetchRange;
    }
    var self = this;
    const getIt = () => {
      getData(`timeclock/feed${this.props['match']['params']['user_id'] ? "/" + this.props['match']['params']['user_id'] : "/" + this.state.chosenCalendar}`, fetchRange, this.props.token)
        .then((data) => {
          if (data.status === "Success") {
            self.setState({
              events: data.data.calendar,
              // calendarList: data.data.calendarList,
              dataLoaded: true,
              loading: false,
              fetchRange: {
                ...fetchRange
              }
            });
          }
        })
        .catch(error => {
          console.error(error);
        });
    }
    getIt();
  }

  saveEntry(formData) {
    if (this.state.formData['start'] > this.state.formData['end']) {
      EventClient.emit("TOAST_ERROR", "Clock In must be before Clock Out");
      return;
    }
    // console.log(formData)
    postData(`timeclock/${formData['uid']}/${formData['id']}`, formData)
      .then((data) => {
        if (data.status === "Success") {
          EventClient.emit("TOAST_SUCCESS", "Time Entry Updated");
          this.closeMe(() => {
            this.updateData();
          })
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  deleteEntry(uid, id) {
    if (confirm(`Are you sure you want to remove this time entry?`)) {
      deleteData(`timeclock/${uid}/${id}`, {})
        .then((data) => {
          if (data.status === "Success") {
            EventClient.emit("TOAST_SUCCESS", "Time Entry Deleted");
            this.closeMe(() => {
              this.updateData();
            })
          }
        })
        .catch(error => {
          console.error(error);
        });
    }
  }

  closeMe(cb) {
    this.setState({editID: null, formData: {}}, cb)
  }


  eventStyleGetter(event, start, end, isSelected) {
    if (event.subStatus > 0) {
      const styleIt = getAARStatus(event.subStatus);
      event.eventColor = styleIt.bgColor || event.eventColor;
      event.color = styleIt.color || event.color;
    }
    var style = {
      backgroundColor: event.colorOverride || event.eventColor || "",
      color: event.color || "",
      fontSize: 10,
      zIndex: 100
    };
    return {
      style: style
    };
  }

  addSelection(selection) {
    // console.log({start: selection.start, end: selection.end});
    EventClient.emit("CALENDAR_ENTRY_ADD", {
      addSelection: {start: selection.start, end: selection.end},
      calId: this.state.chosenCalendar,
      lead: this.state.lead,
      followup: this.props.followup
    })
    // this.setState({addSelection: {start: selection.start, end: selection.end}, showAddCalEntry: true})
  }

  calculateDates(value) {
    const localDate = makeDate(value);
    const utcDate = formatDateTime(localDate).replace(" ", "T")
    const epochTime = localDate.getTime() / 1000;
    return {utcDate, epochTime}
  }

  timeEntryUpdate(type, value) {
    const {utcDate, epochTime} = this.calculateDates(value);

    if (utcDate && epochTime) {
      if (type === "clockin") {
        this.setState({formData: {...this.state.formData, start: epochTime, clockin: utcDate}})
      } else if (type === "clockout") {
        this.setState({formData: {...this.state.formData, end: epochTime, clockout: utcDate}})
      }
    }
  }

  render() {
    let self = this;
    const eventStart = function (event) {
      return forceSingleTimeZone(formatTimeFromEpoch(event.start));
    };
    const eventEnd = function (event) {
      return forceSingleTimeZone(formatTimeFromEpoch(event.end));
    };
    const formatHoursMinutesFromSeconds = function (seconds) {
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds - (hours * 3600)) / 60);
      let hoursMins = (hours > 0 ? hours + "h " : "") + (minutes > 0 ? minutes + "m" : "");
      return hoursMins.length > 0 ? hoursMins : `${seconds}s`
    }
    const titleAccessor = function (event) {
      let status = "";
      if (event.duration > 0) {
        status = " (" + formatHoursMinutesFromSeconds(event.duration) + ")";
      }
      return (Number(event.allDay) === 0 ? displayMilHoursMinutesFromTime(eventStart(event)) + " " : "") + event.title + status;
    };
    const agendaTitleAccessor = function (event) {
      return <div style={{cursor: "pointer"}}
                  onClick={() => self.setState({editID: event.id})}>{titleAccessor(event)}</div>;
    };

    const dateFilter = function (events) {
      if (self.state.dateRange.start > 0 && self.state.dateRange.end > 0) {
        return events.filter((event) => event.start >= (self.state.dateRange.start.toDate().getTime() / 1000) && event.start <= (self.state.dateRange.end.toDate().getTime() / 1000))
          .map((evt) => ({
            ...evt,
            clockout: evt.clockout && evt.clockout.split(".")[0],
            clockin: evt.clockin && evt.clockin.split(".")[0],
            test: true
          }));
      } else {
        return [];
      }
    }

    let events = dateFilter(this.state.events);

    const localTime = (epochTime) => {
      return formatDateTimeLocal(formatUTCTimeFromEpoch(epochTime));
    }
    return (
      <div className="animated fadeIn">
        <LoadingDialog isOpen={this.state.loading}/>
        {this.state.dataLoaded && (
          <Card>
            <CardHeader style={{display: 'inherit'}}>
              <i className="icon-calendar"></i>
              My TimeClock Calendar
              <div className="card-actions">
                {/*<button onClick={() => EventClient.emit("CALENDAR_ENTRY_ADD", {*/}
                {/*  calId: this.state.chosenCalendar,*/}
                {/*  lead: this.state.lead,*/}
                {/*  followup: this.props.followup*/}
                {/*})}>*/}
                {/*  <small className="text-muted">Add</small>*/}
                {/*</button>*/}
                <button onClick={() => this.updateData()}>
                  <small className="text-muted">Refresh</small>
                </button>
              </div>

            </CardHeader>
            <CardBody>
              <BigCalendar
                localizer={localizer}
                views={['month', 'week', 'day']}
                events={events}
                step={30}
                popup={true}
                showAllEvents
                defaultDate={new Date()}
                defaultView='month'
                toolbar={true}
                selectable={true}
                eventPropGetter={this.eventStyleGetter}
                onSelectEvent={(event) => this.setState({editID: event.id, formData: event})}
                // onSelectEvent={console.log}
                rowLimit={20}
                startAccessor={eventStart}
                endAccessor={eventEnd}
                titleAccessor={titleAccessor}
                // tooltipAccessor={titleAccessor}
                onClick={console.log}
                onEventResize={console.log}
                draggableAccessor={event => true}
                onNavigate={(date) => this.setCurrentDate(date)}
                onView={(view) => this.setCurrentView(view)}
                // onSelectSlot={(selection) => this.addSelection(selection)}
                style={{height: '80em'}}
              />
              {/*<BigCalendar className="calendar-portrait-show"*/}
              {/*             localizer={localizer}*/}
              {/*             views={['agenda']}*/}
              {/*             events={events}*/}
              {/*             step={30}*/}
              {/*             popup*/}
              {/*             defaultDate={new Date()}*/}
              {/*             defaultView='agenda'*/}
              {/*             toolbar={true}*/}
              {/*             selectable={true}*/}
              {/*             eventPropGetter={this.eventStyleGetter}*/}
              {/*  // onSelectEvent={(event) => EventClient.emit("CALENDAR_ENTRY_EDIT", {*/}
              {/*  //   eventId: event.id,*/}
              {/*  //   calId: this.state.chosenCalendar,*/}
              {/*  //   lead: this.state.lead,*/}
              {/*  //   followup: this.props.followup*/}
              {/*  // })}*/}
              {/*  // startAccessor={eventStart}*/}
              {/*  // endAccessor={eventEnd}*/}
              {/*  // titleAccessor={agendaTitleAccessor}*/}
              {/*  // tooltipAccessor={agendaTitleAccessor}*/}
              {/*             onClick={console.log}*/}
              {/*             onEventResize={console.log}*/}
              {/*             draggableAccessor={event => true}*/}
              {/*             onNavigate={(date) => this.setCurrentDate(date)}*/}
              {/*             onView={(view) => this.setCurrentView(view)}*/}
              {/*  // onSelectSlot={(selection) => this.addSelection(selection)}*/}
              {/*             style={{height: '80em'}}*/}
              {/*/>*/}
            </CardBody>
          </Card>
        )}
        {this.state.editID && (
          <MakeDialog isOpen={true}
                      header={`TimeClock Entry for ${this.state.formData['title']}`}
                      footer={(
                        <Fragment>
                          <Button color="primary"
                                  disabled={!hasPermission(RequiredPermissions.TimeClockManager)}
                                  onClick={() => this.saveEntry(this.state.formData)}>Save</Button>
                          <Button color="danger"
                                  disabled={!hasPermission(RequiredPermissions.TimeClockManager)}
                                  onClick={() => this.deleteEntry(this.state.formData['uid'], this.state.editID)}>Delete</Button>
                          <Button color="secondary"
                                  onClick={() => this.closeMe()}>Close</Button>
                        </Fragment>)}
          >
            <Row>
              <Col xs="6" lg="4">
                <FormGroup>
                  <Label for="clockin">Clock In</Label>
                  <InputGroup>
                    <Input
                      type="datetime-local"
                      id="clockin"
                      step={"1"}
                      value={localTime(this.state.formData['start'])}
                      onChange={(evt) => this.timeEntryUpdate('clockin', evt.target.value)}
                    />
                  </InputGroup>
                  <FormText color="muted">
                    Shown in your timezone
                  </FormText>
                </FormGroup>
              </Col>
              <Col xs="6" lg="4">
                <FormGroup>
                  <Label for="clockout">Clock Out</Label>
                  <InputGroup>
                    <Input
                      type="datetime-local"
                      id="clockout"
                      step={"1"}
                      value={localTime(this.state.formData['end'])}
                      min={localTime(this.state.formData['start'])}
                      onChange={(evt) => this.timeEntryUpdate('clockout', evt.target.value)}
                    />
                  </InputGroup>
                  <FormText color="muted">
                    Shown in your timezone
                  </FormText>
                </FormGroup>
              </Col>
            </Row>
          </MakeDialog>
        )}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/containers/Timeclock/MyCalendar.js